import * as Sentry from '@sentry/react';

/**
 * Sentry Error Boundary wrapper
 * Catches JavaScript errors in child components and reports them to Sentry
 */
export const SentryErrorBoundary = Sentry.ErrorBoundary;

/**
 * Default fallback component for error boundaries
 */
export function ErrorFallback({ error, resetError }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <h2 style={{ color: '#333', marginBottom: '10px' }}>
        Oops! Something went wrong
      </h2>
      <p style={{ color: '#666', marginBottom: '20px' }}>
        We've been notified and are working to fix it.
      </p>
      {resetError && (
        <button
          onClick={resetError}
          style={{
            padding: '10px 20px',
            backgroundColor: '#11a5ea',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          Try Again
        </button>
      )}
    </div>
  );
}

/**
 * HOC to wrap components with Sentry error boundary
 */
export function withSentryErrorBoundary(Component, fallback) {
  return function WrappedComponent(props) {
    return (
      <SentryErrorBoundary fallback={fallback || <ErrorFallback />}>
        <Component {...props} />
      </SentryErrorBoundary>
    );
  };
}
